import { assignInlineVars } from "@vanilla-extract/dynamic";
import React from "react";
import { Heading } from "web/react/emo/heading";
import { Text } from "web/react/emo/text";
import { View } from "web/react/emo/view";
import { gettext } from "web/script/modules/django-i18n";
import { ArticleCardSerializer } from "web/types/serializers";
import * as styles from "./primary-article-card.css";

interface PrimaryArticleCardProps
    extends Pick<
        ArticleCardSerializer,
        "title" | "thumbnails" | "is_sponsored" | "caption" | "article_url"
    > {
    onClick: (area: string) => void;
}

export function PrimaryArticleCard({
    title,
    thumbnails,
    is_sponsored: isSponsored,
    caption,
    article_url: articleUrl,
    onClick,
}: PrimaryArticleCardProps): React.ReactElement {
    return (
        <div data-testid="editorial-content-card-primary">
            <a href={articleUrl}>
                <View className={styles.primaryArticleContent}>
                    <View onClick={() => onClick("image")} dataTestId="primary-article-image">
                        <picture className={styles.flexContainer}>
                            <source media={styles.desktopMedia} srcSet={thumbnails?.landscape.lg} />
                            <source media={styles.mobileMedia} srcSet={thumbnails?.portrait.lg} />
                            <img className={styles.thumbnailMask} src={thumbnails?.landscape.lg} />
                        </picture>
                        <View
                            style={assignInlineVars({ [styles.overlayBackgroundHeight]: "56%" })}
                            className={styles.thumbnailTextOverlayBackground}
                        />
                    </View>
                    <View
                        paddingBottom="md"
                        paddingLeft={{ sm: "sm", md: "md" }}
                        paddingRight={{ sm: "lg_v2", md: "none" }}
                        className={styles.thumbnailTextOverlayContainer}
                        onClick={() => onClick("cta")}
                        dataTestId="primary-article-cta"
                    >
                        <View marginBottom="sm">
                            {isSponsored && (
                                <View marginBottom="xxs">
                                    <Text textStyle="caption-3" color="information" upperCase>
                                        {gettext("general.sponsored_label")}
                                    </Text>
                                </View>
                            )}
                            <View marginBottom="xxs">
                                <Heading
                                    textStyle="hero-s"
                                    color="information"
                                    wordBreak
                                    lineLimit={2}
                                >
                                    {title}
                                </Heading>
                            </View>
                            <Text textStyle="body-s" color="grayscale400" lineLimit={2}>
                                {caption}
                            </Text>
                        </View>
                        <Text textStyle="body-s-bold" color="information" underline>
                            {gettext("general.read_and_shop")}
                        </Text>
                    </View>
                </View>
            </a>
        </div>
    );
}
